<template>
   <el-dialog title="服务项目备注" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false"
               :close-on-press-escape="false" :append-to-body="true" width="70%">
  <div class="user">
    <!--添加任务-->

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="remark" label="备注"></el-table-column>
            <el-table-column prop="name" label="照片" width="200">
                <template  slot-scope="scope">
                  <div style="height: 80px;width:210px; overflow-x:auto;">
                    <div v-for="(item,index) in scope.row.images" :key="index" style="float: left;">
                      <el-image style="width: 50px; height: 50px;" :src="item.file_path" fit="fit"
                      ref="preview" :preview-src-list="scope.row.images_arr"
                      ></el-image>
                    </div>
                    <div style="clear: both;"></div>
                  </div>
                  
                  
                </template>

            </el-table-column>
            <el-table-column prop="opuser.nickName" label="前端最后编辑人员"></el-table-column>
            <el-table-column  label="后端最终编辑人员">
              <template slot-scope="scope">
                <div v-if="scope.row.opshopuser &&  scope.row.opshopuser.user_name">{{ scope.row.opshopuser.user_name }}
                <span v-if=" scope.row.opshopuser.real_name">({{ scope.row.opshopuser.real_name }})</span>
                </div>
              </template>

            </el-table-column>
            
            
            <!-- <el-table-column prop="status" label="状态"></el-table-column> -->
            <el-table-column prop="sort" label="排序"></el-table-column>
         

  
            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            <el-table-column prop="update_time" label="修改时间" width="150"></el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    
    <Add :open_add="open_add" v-if="open_add" :order_service_id="order_service_id"   @close="closeAdd"></Add>
    <Edit :open_add="open_edit"  :order_service_remark_id="order_service_remark_id"  v-if="open_edit"   @close="closeEdit"></Edit>
  
  </div>
  </el-dialog>

</template>

<script>
  import ProductApi from '@/api/product.js';
  import Add from './part/add.vue';
  import Edit from './part/edit.vue';
  export default {
    components: {
      Add,
      Edit
    },
    inject: ['reload'],
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索表单对象*/
        form: {
          service_status:0,
        },
        formInline: {
          search:""
        },

        open_add:false,
        open_edit:false,
        order_service_remark_id:"",
        dialogVisible: true,
      };
    },
    props:["order_service_id"],
    created() {

      /*获取列表*/
      this.getTableList();
    },
    methods: {
      serviceChange(e){
        var self = this;
        var Params = {
          service_status:this.form.service_status
        }
        ProductApi.service_setting(Params, true)
          .then(data => {
            self.loading = false;
            console.log(data)
            if(data.code == 1){
              self.$message({
                    message: '保存成功',
                    type: 'success'
                  });
            }
          })
          .catch(error => {
          });

      },
       /*关闭添加*/
    closeAdd(e){
      this.open_add=false;
      this.getTableList();
    },
    closeEdit(e){
      this.open_edit=false;
      this.getTableList();
    },
    getData(){
      this.getTableList();
    },
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = this.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        Params.order_service_id = self.order_service_id
        self.loading = true;
        ProductApi.list_remark(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
            self.form = data.data.setting
          })
          .catch(error => {
          });
      },

      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },

      /*添加任务*/
      addClick() {
        this.open_add = true
      },

      /*编辑活动*/
      editClick(row) {
        this.order_service_remark_id = row.order_service_remark_id;
        this.open_edit = true
      },
        /*关闭弹窗*/
        dialogFormVisible() {
                this.$emit('close', {openDialog: false});
            },

      /*删除*/
      deleteClick(row) {
        let self = this;
        self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            ProductApi.del_remark(
              {
                order_service_remark_id: row.order_service_remark_id
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.getTableList();
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });
          })
          .catch(() => {
          });
      }
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/user/user/service/index.vue